module.exports = __webpack_public_path__ + "assets/img/teacher_top1.6e0edaf7.png";